import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from "@angular/core";

@Component({
	selector: "app-control-box",
	templateUrl: "./control-box.component.html",
	styleUrls: ["./control-box.component.scss"],
	encapsulation: ViewEncapsulation.None,
})
export class ControlBoxComponent implements OnInit {
	constructor() {}

	@Input() icon: string = null;
	@Input() value: string = null;
	@Input() headerText = "Default Header Text";
	@Input() detailText = "Default Detail Text";
	@Input() isSelected = false;
	@Output() controlBoxEmitter: EventEmitter<string> = new EventEmitter();

	ngOnInit(): void {}

	controlBoxClick() {
		this.controlBoxEmitter.emit(this.value);
	}
}
